
import React from 'react';
import { Badge } from '../ui/badge';
import { OptimizedImage } from '../ui/OptimizedImage';
import { getProductTitle } from '../../utils/dataFallbacks';

export function ProductImageGallery({ product }) {
  const { image_url, brand, category, discount, is_prime } = product;
  const title = getProductTitle(product);

  return (
    <div className="relative aspect-square bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 flex justify-center items-center rounded-2xl overflow-hidden">
      {image_url ? (
        <OptimizedImage
          src={image_url}
          alt={`${brand || 'Product'} ${title} - High quality ${category || 'tech product'} image with detailed view`}
          className="w-auto h-auto object-contain dark:brightness-90 dark:contrast-125 dark:saturate-110"
          priority={true}
          fetchpriority="high"
          fallback="/placeholder-product.png"
        />
      ) : (
        <div className="w-full h-full bg-gray-100 flex items-center justify-center">
          <span className="text-gray-400">No image available</span>
        </div>
      )}

      {/* Discount Badge */}
      {discount > 0 && (
        <div className="absolute top-2 left-2">
          <Badge className="bg-red-600 text-white font-bold px-2 py-1">
            {Math.round(discount)}% off
          </Badge>
        </div>
      )}

      {/* Prime Badge */}
      {is_prime && (
        <div className="absolute top-2 right-2">
          <Badge className="bg-blue-600 text-white px-2 py-1">
            Prime
          </Badge>
        </div>
      )}
    </div>
  );
}
